export enum CustomAtsIntegrationType {
  Comeet = 'COMEET',
  Greenhouse = 'GREENHOUSE',
  Ashby = 'ASHBY'
}
